<template>
  <div class="item" :class="[hairline,{avatar:avatar,thumb:thumb}]" @click="bindClick">
    <div class="item-left" v-if="leftSlotStatus">
      <slot name="item-left">
        <span v-if="leftIcon" class="icon" :class="leftIcon"></span>
        <v-image :src="avatar" alt="" v-if="avatar" :cdn="cdn"/>
        <v-image :src="thumb" alt="" v-if="thumb" :cdn="cdn"/>
      </slot>
    </div>
    <div class="item-content" @click="bindClick">
      <slot name="item-content">
        <h2 v-if="headline">{{headline}}</h2>
        <h3 v-if="title">{{title}}</h3>
        <h4 class="label" v-if="label">{{label}}</h4>
        <p class="desc" v-if="desc">{{desc}}</p>
      </slot>
    </div>
    <div class="item-right" :class="{'van-hairline--left':lineBetween}" v-if="rightSlotStatus" @click="clickRight">
      <slot name="item-right">
        <span v-if="rightIcon" class="icon" :class="rightIcon"></span>
      </slot>
    </div>
    <router-link :tag="vTag" :to="to" class="link" v-if="to"></router-link>
  </div>
</template>
<script>
export default {
  data () {
    return {
      tag: 'div'
    }
  },
  props: {
    leftIcon: String,
    rightIcon: String,
    title: String,
    label: String,
    desc: String,
    avatar: String,
    headline: String,
    thumb: String,
    lineBetween: Boolean,
    cdn: Boolean,
    vTag: {
      type: String,
      default: 'div'
    },
    to: {
      type: String,
      default: ''
    },
    hairline: {
      type: String
    }
  },
  computed: {
    leftSlotStatus () {
      return !(!this.$slots['item-left'] && !this.leftIcon && !this.avatar && !this.thumb)
    },
    rightSlotStatus () {
      return !(!this.$slots['item-right'] && !this.rightIcon)
    }
  },
  methods: {
    bindClick (e) {
      this.$emit('click', e)
    },
    clickRight (e) {
      this.$emit('clickRight', e)
    }

  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.item {
  padding: 10px;
  font-size: $font-size-base;
  background: $light;
  display: flex;
  align-items: center;
  position: relative;
  color: $dark06;
  &.avatar {
    .item-left {
      img {
        width: 32px;
        height: 32px;
        display: block;
      }
    }
  }
  .link {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: inherit;
  }
  &.thumb {
    .item-left {
      img {
        width: 105px;
        height: 85px;
        border-radius: 6px;
        display: block;
      }
    }
  }
  .item-content {
    flex: 1;
    :nth-child(2) {
      margin-top: 3px;
    }
    :nth-child(3) {
      margin-top: 3px;
    }
    h2 {
      font-weight: normal;
      color: $dark;
    }
    h3 {
      font-weight: normal;
      color: $dark;
    }
    h4 {
      font-size: $font-size-base;
      color: $dark06;
    }
    p {
      font-size: $font-size-base;
      &.desc {
        color: $dark09;
      }
      &.label {
        color: $dark06;
      }
    }
  }

  .item-left {
    margin-right: 10px;
  }
  .item-right {
    margin-left: 10px;
  }
}

.icon {
  font-size: 20px;
  color: #999;
  //  color: $dark06;
  // width: 30px;
  // height: 30px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
</style>
